import React from 'react';
import { inject, observer } from 'mobx-react';
import AgentUdeMetricsView from 'app/views/synthetics/components/agentResults/AgentUdeMetricsView';
import MetricsView from 'app/views/synthetics/components/agentResults/MetricsView';
import LoadingPanel from './LoadingPanel';

@inject('$auth')
@observer
export default class MetricsPanel extends React.Component {
  render() {
    const {
      $auth,
      test,
      agentResults,
      targetResults,
      trendTargetResults,
      agent_id,
      target,
      loading,
      onChangeResultTimeMs
    } = this.props;
    const { timelineBounds, resultTimeMs, loadingTrendDetailResults } = test.agentResults;
    const hasResults = loading || (test.agentResults.hasResults && targetResults.hasResults);
    // UdeDataViewWrapper renders nothing without embedded_ude, so keep the legacy charts for those users
    const hasEmbeddedUde = $auth.hasPermission('embedded_ude', { overrideForSudo: false });
    // Mesh/agent tests filter UDE by dst_agent; older links carry the target agent's IP instead of its ID
    const udeTarget = test.agentResults.targetAgentId || target;
    // UDE charts render their own empty states, independent of the legacy results
    const empty = !hasEmbeddedUde && !hasResults;

    // Use the time range from agentResults (which extends TestResultsState)
    const { actualStartDate, actualEndDate } = test.agentResults;

    return (
      <LoadingPanel
        loading={!loadingTrendDetailResults && loading}
        test={test}
        testResults={test.results}
        empty={empty}
      >
        {hasEmbeddedUde ? (
          <AgentUdeMetricsView
            test={test}
            agent_id={agent_id}
            target={udeTarget}
            startDate={actualStartDate}
            endDate={actualEndDate}
          />
        ) : (
          <MetricsView
            trendResults={trendTargetResults}
            test={test}
            agent_id={agent_id}
            target={target}
            allowFlowQuery={agentResults.allowFlowQuery}
            displayFlowQuery={targetResults.displayFlowQuery}
            pingHealthTs={targetResults.pingHealthTs}
            dnsHealthTs={targetResults.dnsHealthTs}
            dnsHealthTsResult={targetResults.dnsHealthTsResult}
            httpHealthTs={targetResults.httpHealthTs}
            dnsHealthAggregates={targetResults.dnsHealthAggregates}
            httpHealthAggregates={targetResults.httpHealthAggregates}
            pingHealthAggregates={targetResults.pingHealthAggregates}
            throughputHealthTs={targetResults.throughputHealthTs}
            throughputHealthAggregates={targetResults.throughputHealthAggregates}
            trafficFlowQuery={targetResults.trafficFlowQuery}
            resultTimeMs={resultTimeMs}
            timelineBounds={timelineBounds}
            onHover={onChangeResultTimeMs}
          />
        )}
      </LoadingPanel>
    );
  }
}
